@use "foundation/colors";
@use "foundation/responsive";
@use "foundation/typography_base";

.modal-container {
  :global .modal {
    :global .modal-content {
      overflow-y: hidden;
      text-align: left;

      :global .section {
        padding: 32px;

        h3 {
          max-width: none;
          margin-bottom: 2rem;
        }
      }
    }
  }

  &.between_certain_time {
    :global .modal {
      :global .modal-content {
        $max-width: 919px;
        max-width: $max-width;

        @media (max-width: calc(#{$max-width} + 32px)) {
          margin-left: 20px;
          margin-right: 20px;
        }
      }
    }
  }

  &.run_or_skip_on_a_certain_day {
    :global .modal {
      :global .modal-content {
        width: 640px;
      }
    }
  }

  &.check_for_a_keyword {
    :global .modal {
      :global .modal-content {
        width: 827px;
      }
    }

    .helper-text {
      font-size: 14px !important;
    }
  }

  .helper-text {
    font-size: 16px;
    font-weight: 600;
    line-height: 1.5555555556rem;

    a {
      font-weight: 700;
      text-decoration: underline;
    }
  }

  .template {
    width: 100%;
    background: colors.$neutrals-light-grey;
    padding: 16px 32px;
    border-radius: 10px;
    font-family: typography_base.$code;
    text-align: center;

    select,
    input[type="text"] {
      font-family: typography_base.$code;

      width: auto;
      font-size: 14px;
      font-weight: 400;
      margin: 0.5em;
    }
  }
}

.ai-generator-modal {
  :global .modal {
    :global .modal-content {
      $max-width: 736px;
      max-width: $max-width;
      overflow-y: hidden;

      @media (max-width: calc(#{$max-width} + 32px)) {
        margin-left: 20px;
        margin-right: 20px;
      }

      :global .section {
        display: flex;
        flex-direction: column;
        gap: 32px;
        text-align: left;

        h3 {
          font-size: 24px;
          font-weight: 700;
          line-height: 32px;
          color: colors.$primary-eerie-black;
          max-width: none;
          margin: 0;
        }

        p {
          font-size: 16px;
          font-weight: 600;
          line-height: 24px;
          color: colors.$primary-eerie-black;
          margin: 0;
          text-align: left;
        }
      }
    }
  }

  .form-container {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 32px;
  }

  .connector-line {
    position: absolute;
    left: 50%;
    top: 0;
    transform: translateX(-50%);
    width: 4px;
    height: 472px;
    background: colors.$neutrals-light-grey;
    z-index: 0;
  }

  .field-wrapper {
    position: relative;
    z-index: 1;
  }

  .field-container {
    background: colors.$neutrals-light-grey;
    padding: 16px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    box-sizing: border-box;
  }

  .field-label {
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    color: colors.$primary-eerie-black;
    text-align: left;
  }

  .textarea {
    width: 100%;
    margin: 0 !important;
    padding: 16px 24px 16px 20px;
    background: colors.$primary-white;
    border: none;
    border-radius: 8px;
    box-sizing: border-box;
    font-size: 16px !important;
    font-weight: 700;
    line-height: 24px;
    color: colors.$primary-eerie-black;
    resize: vertical;
    min-height: auto;

    &::placeholder {
      color: colors.$neutrals-grey;
      font-size: 16px;
      font-weight: 700;
    }

    &:focus {
      outline: 2px solid colors.$secondary-blue;
      outline-offset: 2px;
    }

    &[readonly] {
      background: colors.$primary-white;
      cursor: default;
    }

    &.code-font {
      font-family: typography_base.$code;
      font-size: 14px !important;
      font-weight: 400;
      line-height: 28px;
      color: colors.$primary-eerie-black;

      &::placeholder {
        font-family: typography_base.$code;
        font-size: 14px;
        font-weight: 400;
        line-height: 28px;
      }
    }

    &.loading {
      background: rgba(255, 255, 255, 0.6);
    }
  }

  .button-row {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 16px;
  }

  %primary-button {
    padding: 4px 40px;
    background: colors.$primary-eerie-black;
    border: none;
    border-radius: 100px;
    font-size: 16px;
    font-weight: 700;
    line-height: 48px;
    color: colors.$primary-white;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover:not(:disabled) {
      background: colors.$neutrals-darker-grey;
    }

    &:disabled,
    &.disabled {
      background: colors.$neutrals-grey;
      cursor: not-allowed;
    }
  }

  .generate-button {
    @extend %primary-button;
  }

  .actions {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 24px;
    margin-top: 16px;
  }

  .close-button {
    background: none;
    border: none;
    padding: 0;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    color: colors.$primary-eerie-black;
    cursor: pointer;
    transition: opacity 0.2s;

    &:hover {
      opacity: 0.8;
    }
  }

  .copy-button {
    @extend %primary-button;
  }
}
